/** Map an external offer onto a new offer the way API auto-create does. */

/** Offer fields the API / external offer owns for cap and payout groups. */
export function apiContentFromExternal(eo) {
	if (!eo) {
		return {};
	}
	return {
		daily_click_cap: eo.daily_click_cap,
		daily_impression_cap: eo.daily_impression_cap,
		daily_conversion_cap: eo.daily_conversion_cap,
		daily_conversion_budget: eo.daily_conversion_budget,
		payout: eo.payout,
		payout_type: eo.payout_type,
	};
}

export function campaignTypeFromExternal(eo) {
	const original = eo && eo.original;
	if (!original || !Object.prototype.hasOwnProperty.call(original, 'is_vta')) {
		return null;
	}
	return +original.is_vta ? 'vta' : 'cta';
}

export function prepareOfferFromExternal(eo, emptyOffer) {
	const o = emptyOffer;
	o.external_offer_id = eo.id;
	o.externalOffer = eo;
	o.advertiser_id = eo.advertiser_id;
	o.name = eo.name;
	o.description = eo.description;
	o.kpi = eo.restrictions;
	o.payout = eo.payout;
	o.currency = eo.currency;
	o.payout_type = eo.payout_type;
	o.country = eo.country;
	o.platform = eo.platform;
	o.tracking_url = eo.tracking_url;
	o.impression_url = eo.impression_url;
	o.preview_url = eo.preview_url;

	// Caps / budget the API fetch writes onto the offer
	o.daily_click_cap = eo.daily_click_cap;
	o.daily_impression_cap = eo.daily_impression_cap;
	o.daily_conversion_cap = eo.daily_conversion_cap;
	o.daily_conversion_budget = eo.daily_conversion_budget;

	o.black_list = eo.black_list;
	o.white_list = eo.white_list;
	o.geo_targeting = eo.geo_targeting;
	o.app_id = eo.app_id;
	o.app_version = eo.app_version;
	o.sdk_version = eo.sdk_version;
	if (eo.platform_internal) {
		o.platform_internal = eo.platform_internal;
	}
	if (eo.kpi_value) {
		o.kpi_value = eo.kpi_value;
	}

	const app = eo.app;
	if (app) {
		o.store_icon = app.icon;
		o.store_bundle_id = app.package_id;
		o.store_package_id = app.app_id;
	}

	const carrierBlwl = eo.carrier_blwl;
	if (carrierBlwl) {
		o.carrier_whitelist = carrierBlwl.whitelist || null;
		o.carrier_blacklist = carrierBlwl.blacklist || null;
	}

	const osVersionTargeting = eo.os_version_targeting;
	if (osVersionTargeting) {
		o.os_targeting = osVersionTargeting.os || null;
		o.os_targeting_version_min = osVersionTargeting.version_min || null;
		o.os_targeting_version_max = osVersionTargeting.version_max || null;
		o.os_version_blacklist = osVersionTargeting.blacklist || [];
	}

	const campaignType = campaignTypeFromExternal(eo);
	if (campaignType) {
		o.campaign_type = campaignType;
	}

	o.events = [];
	if (eo.events) {
		eo.events.forEach((e) => {
			o.events.push({
				name: '' + e.name,
				label: '' + (e.label ? e.label : e.name),
				payout_mode: e.payout_mode || (e.payout ? 'fixed' : 'none'),
				payout: e.payout ? e.payout : e.payable ? o.payout : 0,
			});
		});
	}
	return o;
}
